import { ReactNode, Suspense } from 'react';
import { Provider } from 'react-redux';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import * as Sentry from '@sentry/react';
import styled from 'styled-components';

import 'react-toastify/dist/ReactToastify.css';
import '@wix/design-system/styles.global.css';

import * as Pages from './pages';
import { store } from './store/store';
import { wixTheme } from './theme';

import { AppRoutes, WithAuth } from './routes';
import { WixDesignSystemProvider } from '@wix/design-system';

const renderAuthRoute = (component: ReactNode) => <WithAuth>{component}</WithAuth>;

export const App = () => {
  return (
    <div className="App">
      <ThemeProvider theme={wixTheme}>
        <CssBaseline />

        <Provider store={store}>
          <Sentry.ErrorBoundary fallback={<p>An error has occurred</p>}>
            <Suspense>
              <BrowserRouter>
                <WixDesignSystemProvider features={{ newColorsBranding: true }}>
                  <PageWrapper>
                    <Routes>
                      <Route path={AppRoutes.MAIN.get()} element={renderAuthRoute(<Pages.MainPage />)} />
                      <Route path={AppRoutes.PRODUCT.get()} element={renderAuthRoute(<Pages.ProductPage />)} />
                      <Route path={AppRoutes.WIX_EDITOR.get()} element={<Pages.WixEditorPage />} />
                    </Routes>
                  </PageWrapper>
                </WixDesignSystemProvider>
              </BrowserRouter>
            </Suspense>
          </Sentry.ErrorBoundary>
        </Provider>
      </ThemeProvider>

      <div id="portals-container">
        <ToastContainer />
      </div>
    </div>
  );
};

const PageWrapper = styled.div`
  display: flex;
  min-height: 100vh;
`;
